import { getApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

// Firebase console > Project settings > Cloud Messaging > Web Push certificates > Key pair
const VAPID_KEY = 'BNUBZltBiV5gHsRvP0P4VQCGWn-2DIs7iBcHPqeAh2aotIZS4csOLWbmHfMS4GPzdqyzoAsJY1_9nNN6evM0ZUY';

// Asks for notification permission and saves this device's push token on the user.
// Call directly from a click handler: iOS only allows the permission prompt from a user gesture.
export async function enableNotifications(userId) {
    if (!userId || typeof Notification === 'undefined') {
        return { success: false, reason: 'unsupported' };
    }

    // must be the first await so the user gesture is still active
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
        return { success: false, reason: 'denied' };
    }

    if (!VAPID_KEY) {
        return { success: false, reason: 'missing-vapid-key' };
    }

    try {
        if (!(await isSupported())) {
            return { success: false, reason: 'unsupported' };
        }
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const token = await getToken(getMessaging(getApp()), { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration });
        if (!token) {
            return { success: false, reason: 'no-token' };
        }
        await updateDoc(doc(db, 'Users', userId), { fcmTokens: arrayUnion(token) });
        return { success: true };
    } catch (error) {
        console.error('enableNotifications failed', error);
        return { success: false, reason: 'error', error };
    }
}
